module.exports = __webpack_public_path__ + "img/points.e838e69f.png";